var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-area component"},[(_vm.user)?_c('div',{staticClass:"profile"},[_c('img',{attrs:{"src":_vm.user.image,"alt":_vm.user.name}}),_c('span',[_vm._v("Signed in as "+_vm._s(_vm.user.name)+".")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }